import { CurrencyLocation, CurrencyOptions, DecimalSeparator, RoundingMethod, ThousandsSeparator } from '@empathybroker/ebx-gluon';

export const COP: CurrencyOptions = {
  currencyLocation: CurrencyLocation.APPEND,
  currencySpacing: true,
  decimalDigits: 0,
  decimalSeparator: DecimalSeparator.COMMA,
  currencySymbol: 'COP',
  hideDecimalsIfZero: true,
  roundingMethod: RoundingMethod.ROUND,
  thousandsSeparator: ThousandsSeparator.NONE
};
